module.exports = __webpack_public_path__ + "static/media/User_Icon_3.d12e95e2.svg";